export default {
  'Watermark': 'Watermark',
  'Add Watermark Selection': 'Tambah Pilihan Watermark',
}